import React from "react";
import { Progress, Rate, Typography, Divider } from "antd";

const { Text } = Typography;

interface RatingProgressCardProps {
  title: string;
  rating: number;
  totalRatings: number;
  showDivider?: boolean;
}

const RatingProgressCard: React.FC<RatingProgressCardProps> = ({
  title,
  rating,
  totalRatings,
  showDivider = true,
}) => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
        <Text
          strong
          style={{
            fontSize: 16,
            color: "#1F5782",
          }}
        >
          {title}
        </Text>

        <Rate
          disabled
          defaultValue={rating}
          allowHalf
          character="★"
          style={{
            fontSize: 20,
            color: "#FFC107",
          }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Progress
            percent={(totalRatings / 2000) * 100}
            showInfo={false}
            strokeColor="#1F5782"
            trailColor="#E0E0E0"
            strokeWidth={12}
            style={{ flex: 1 }}
          />
          <Text
            strong
            style={{
              fontSize: 16,
              color: "#1F5782",
            }}
          >
            ({totalRatings})
          </Text>
        </div>
      </div>

      {showDivider && <Divider style={{ margin: "5px 0" }} />}
    </>
  );
};

export default RatingProgressCard;
